/**
 * This adds a bottom spacing for when the navigation is visible on small size, so the content doesn't end
 * behind it at the bottom of the page.
 */

export default function SVPageBottomMargin({ isNavVisible }: { isNavVisible: boolean }) {
	return (
		<>{isNavVisible ? <div className="-sm:block pointer-events-none hidden h-20" /> : null}</>
	);
}
